import {formatPrice, formatPriceZero} from "../domains2/libraries/Utils";
import {isNoThanksProduct, isNoThanksProductId} from "../helper/ProductSelectionHelper";
import appConfig from "../appconfig";
import {mapGetters} from "vuex";
import {getProductPriceWithDiscounts} from "../libraries/globalTemplateSpecific/bm100/utils";
import ProductSelection from "../domains2/orders/ProductSelection";
import {generateOrderLines} from "../integrations/tracking/gtm/gtmHelper";

const tenantConfig = appConfig.tenantConfig;
export default {
	props: ["group", "subProduct", "mainGroup", "productSelection", "changeSubGroupProductSelection", "isNoThanksSelected"],
	data() {
		return {
			productSelectionState: {...this.productSelection},
			timeoutHandle: null,
			cartQuantityDialogShown: false
		};
	},
	computed: {
		...mapGetters(["productCatalog", "groupsWithMandatoryProductSelection"]),
		isGroupWithMandatorySelections() {
			return !!this.checkIfGroupHasSelectionRestrictions(this.group);
		},
		isNoThanks() {
			return isNoThanksProduct(this.product);
		},
		shouldApplyDiscount() {
			if(!this.product.discount) {
				return false;
			}
			const orderLine = generateOrderLines(
				this,
				{
					productCatalog: this.productCatalog,
					productSelections: [ProductSelection.createFromProduct(this.product)],
					...(this.rootProduct && this.rootProduct.departmentId === 2 && { isRootProductMenu: true })
				}
			)[0];
			if(!orderLine || !orderLine.discount) {
				return false;
			}
			// NOTE: this is not the way that we should handle discounts, but I don't have capacity to refactor it now
			// products should have a correct reference to the applied discount
			// but presently it can be any discount that is active in the system and has the product in its scope
			// so the logic for getPriceInGroup can pick up a discount that is not really applied to the product
			// order lines handle discounts correctly so I will use them as a reference, but this must be fixed in the future
			return this.product.discount.discountId === orderLine.discount.discountId;
		},
		subproductPrice() {
			const self = this;
			const priceInGroup = this.rootProduct && this.rootProduct.options.isMiniMenu && self.product.priceStructure
				? self.product.priceStructure.defaultPrice
				: self.product.getPriceInGroup({
					applyDiscount: this.shouldApplyDiscount
				});
			const priceFloat = parseFloat(priceInGroup);
			const price = isNaN(priceFloat) ? 0 : priceFloat;
			const formattedPrice = self.precisionTwoWithZeros ? formatPriceZero(price) : formatPrice(price);
			return self.group.options.customPriceLabel ? `${formattedPrice} ${self.group.options.customPriceLabel}` : formattedPrice;
		},
		precisionTwoWithZeros() {
			return tenantConfig.precisionTwoWithZeros;
		},
		shouldShowDiscountedPrice() {
			return this.rootProduct.options.isMiniMenu
				&& this.product.discount
				&& this.product.discount.voucherPattern.length === 0;
		},
		discountPrice() {
			const productWithDiscountedPrice = getProductPriceWithDiscounts(
				[this.product],
				[ProductSelection.createFromProduct(this.product)],
				this.productCatalog,
				["familyDiscount"]
			);
			return productWithDiscountedPrice[this.product.id] && formatPriceZero(productWithDiscountedPrice[this.product.id].discountPrice);
		}
	},
	methods: {
		doNothing(){},
		checkIfGroupHasSelectionRestrictions(group) {
			return this.groupsWithMandatoryProductSelection[group.id];
		},
		manageMandatoryProductSelections() {
			/**
			 *  This function manages selection when there is mandatory selection. It covers 2 possible scenarios:
			 * 1) There are some selections inside group. If user chooses "No thanks" option, function should deselect all previously selected products automatically.
			 * 2) "No thanks" is chosen. If user chooses something else, function should deselect "No thanks" automatically.
			 */
			const self = this;
			const mainProductSelection = self.subProduct ? self.productSelectionState.groups
				.find(g => g.selectedProducts.find(sp => sp.productId === self.group.productId)).selectedProducts[0] : self.productSelectionState;
			const selectedProducts = mainProductSelection.groups
				.find(g => g.groupId === self.group.id).selectedProducts;
			// there are some cases when ingredients are being used as products, and these are being sent through the main
			// product group. When "no thanks" is selected, these items should be preserved in the selection
			const mainGroupProducts = (this.group || {}).products;
			const productsToKeep = mainGroupProducts && mainGroupProducts.length
				? selectedProducts.reduce((acc, curr) => {
					const productId = typeof curr === "object" ? curr.productId : curr;
					const productBelongsToMainGroup = (mainGroupProducts || []).find(p => p.id === productId);
					if(!productBelongsToMainGroup) {
						acc.push(curr);
					}
					return acc;
				}, [])
				: [];
			const [noThanksOnly, withoutNoThanks] = selectedProducts.reduce((result, item) => {
				result[isNoThanksProductId(item.productId) ? 0 : 1].push(item);
				return result;
			}, [[], []]);
			const selection = self.isNoThanks
				? (self.isNoThanksSelected ? [].concat(productsToKeep) : noThanksOnly.concat(productsToKeep))
				: withoutNoThanks;
			self.changeSubGroupProductSelection(self.mainGroup, self.subProduct, self.group, selection);
		},
		resetTimeout() {
			const self = this;
			window.clearTimeout(self.timeoutHandle);
			self.timeoutHandle = window.setTimeout(() => {
				self.cartQuantityDialogShown = false;
			}, 3000);
		}
	}
};
